<template>
  <v-container>
    <v-row>
      <v-col
        ><h3>
          <b>Agentes de Desenvolvimento</b>
        </h3></v-col
      >
    </v-row>
    <v-row>
      <v-col cols="12" md="4" lg="5">
        <combobox-unidade-regional
          :filter="municipioEixo"
        ></combobox-unidade-regional>
      </v-col>
      <v-col cols="12" md="5" lg="5">
        <municipio-combo
          :filter="municipioEixo"
          @allMunicipio="(e) => (allMunicipio = e)"
          :municipiosPermitidos="municipiosPermitidos"
        ></municipio-combo>
      </v-col>
      <v-col cols="12" md="3" lg="2">
        <v-tooltip bottom :disabled="municipioEixo.municipio.length > 0">
          <template v-slot:activator="{ on, attrs }">
            <span v-bind="attrs" v-on="on" style="display: inline-block">
              <v-btn
                color="primary"
                @click="filtrar"
                :disabled="municipioEixo.municipio.length == 0"
              >
                Filtrar Agentes
              </v-btn>
            </span>
          </template>
          <span>Selecione pelo menos um município para filtrar</span>
        </v-tooltip>
      </v-col>
    </v-row>

    <v-row v-if="!filtroAplicado" class="mt-4">
      <v-col>
        <v-alert
          color="primary"
          dark
          type="info"
          outlined
          prominent
          class="text-center"
        >
          <v-icon left size="24">mdi-information</v-icon>
          <strong
            >Para visualizar e gerenciar os agentes de desenvolvimento</strong
          >
          <br />
          <span class="mt-2 d-block">
            Selecione pelo menos um município nos filtros acima e clique em
            "Filtrar Agentes"
          </span>
        </v-alert>
      </v-col>
    </v-row>

    <v-row v-if="filtroAplicado && cadastrarMunicipiosAds" class="align-center">
      <v-col>
        <v-btn color="primary" @click="adicionarNovoAgente">
          <v-icon left>mdi-plus</v-icon>
          Adicionar Agente
        </v-btn>
      </v-col>
      <v-col style="text-align: right">
        <v-btn color="primary" @click="exportarAgentes" outlined>
          <v-icon left>mdi-file-excel</v-icon>
          Exportar Agentes
        </v-btn>
      </v-col>
    </v-row>
    <v-row v-if="filtroAplicado">
      <v-col>
        <v-data-table
          :headers="headersAgentes"
          :items="agentesDesenvolvimento"
          item-key="adId"
          class="elevation-1"
          :items-per-page="10"
          :footer-props="{ itemsPerPageText: 'Itens por página' }"
          :single-expand="true"
          :expanded.sync="expanded"
        >
          <template v-slot:item.nome="{ item }">
            <div class="d-flex align-center">
              <v-tooltip bottom v-if="item.isNew || item.hasUnsavedChanges">
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    color="orange"
                    class="mr-2"
                    size="18"
                    v-bind="attrs"
                    v-on="on"
                  >
                    mdi-content-save-alert
                  </v-icon>
                </template>
                <span>{{
                  item.isNew ? "Novo agente não salvo" : "Alterações não salvas"
                }}</span>
              </v-tooltip>
              {{ item.nome }}
            </div>
          </template>

          <template
            v-slot:item.actions="{ item }"
            v-if="visualizarMunicipiosAds"
          >
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  outlined
                  color="blue"
                  v-bind="attrs"
                  v-on="on"
                  style="margin-right: 8px"
                  @click="visualizarAgente(item)"
                >
                  <v-icon>mdi-eye</v-icon>
                </v-btn>
              </template>
              <span>{{
                expanded.includes(item) && item.viewMode
                  ? "Fechar"
                  : "Visualizar"
              }}</span>
            </v-tooltip>

            <v-tooltip bottom v-if="editarMunicipiosAds">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  outlined
                  style="margin-right: 8px"
                  color="green"
                  v-bind="attrs"
                  v-on="on"
                  @click="editarAgente(item)"
                >
                  <v-icon>mdi-pencil</v-icon>
                </v-btn>
              </template>
              <span>{{
                expanded.includes(item) && item.editMode ? "Cancelar" : "Editar"
              }}</span>
            </v-tooltip>

            <v-tooltip bottom v-if="excluirMunicipiosAds">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  color="red"
                  v-bind="attrs"
                  outlined
                  v-on="on"
                  @click="excluirAgente(item)"
                >
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
              </template>
              <span>Excluir</span>
            </v-tooltip>
          </template>

          <template v-slot:expanded-item="{ item }">
            <td colspan="3" class="pa-4">
              <v-card flat>
                <v-card-title class="subtitle-1">
                  <span v-if="item.viewMode"
                    >Visualização do Agente de Desenvolvimento</span
                  >
                  <span v-else-if="item.isNew"
                    >Adicionar novo Agente de Desenvolvimento</span
                  >
                  <span v-else>Editar Agente de Desenvolvimento</span>
                  <v-spacer></v-spacer>
                </v-card-title>
                <v-card-text>
                  <v-row>
                    <v-col cols="12" md="6">
                      <v-text-field
                        v-model="item.nome"
                        label="Nome"
                        :readonly="item.viewMode || !item.editMode"
                        outlined
                        hide-details="auto"
                        dense
                        @input="marcarComoAlterado(item)"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-text-field
                        v-model="item.cpf"
                        label="CPF"
                        :readonly="item.viewMode || !item.editMode"
                        outlined
                        dense
                        hide-details="auto"
                        v-mask="'###.###.###-##'"
                        @input="marcarComoAlterado(item)"
                      ></v-text-field>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col cols="12" md="6">
                      <v-text-field
                        v-model="item.email1"
                        label="Email Principal"
                        :readonly="item.viewMode || !item.editMode"
                        outlined
                        dense
                        type="email"
                        hide-details="auto"
                        @input="marcarComoAlterado(item)"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="6">
                      <v-text-field
                        v-model="item.email2"
                        label="Email Secundário"
                        :readonly="item.viewMode || !item.editMode"
                        outlined
                        dense
                        hide-details="auto"
                        type="email"
                        @input="marcarComoAlterado(item)"
                      ></v-text-field>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col cols="12" md="4" xl="5">
                      <v-text-field
                        v-model="item.telefone"
                        label="Telefone"
                        :readonly="item.viewMode || !item.editMode"
                        outlined
                        dense
                        hide-details="auto"
                        v-mask="'(##) #####-####'"
                        @input="marcarComoAlterado(item)"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="4" xl="5">
                      <v-text-field
                        v-model="item.nascimento"
                        label="Data de Nascimento"
                        :readonly="item.viewMode || !item.editMode"
                        outlined
                        dense
                        hide-details="auto"
                        v-mask="'##/##/####'"
                        placeholder="DD/MM/AAAA"
                        @input="marcarComoAlterado(item)"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="4" xl="2">
                      <v-text-field
                        v-model="item.escolaridade"
                        label="Escolaridade"
                        :readonly="item.viewMode || !item.editMode"
                        outlined
                        hide-details="auto"
                        dense
                        @input="marcarComoAlterado(item)"
                      ></v-text-field>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col cols="12" md="4">
                      <municipio-combo
                        :filter="item"
                        @changeCity="
                          item.codigoIbge = item.municipio.codigoIBGE;
                          marcarComoAlterado(item);
                        "
                        outlined
                        dense
                        :municipiosProps="allMunicipio"
                        :filterByMunicipio="municipioEixo.municipio"
                        :readOnly="item.viewMode || !item.editMode"
                        :isMultiple="false"
                        :codigoIbge="item.codigoIbge"
                      ></municipio-combo>
                    </v-col>

                    <v-col cols="12" md="4">
                      <v-select
                        v-model="item.status"
                        :items="statusOptions"
                        label="Status"
                        :readonly="item.viewMode || !item.editMode"
                        outlined
                        hide-details="auto"
                        dense
                        @change="marcarComoAlterado(item)"
                      ></v-select>
                    </v-col>
                    <v-col cols="12" md="4">
                      <div>Possui Curso AD Básico?</div>
                      <v-radio-group v-model="item.cursoAdBasicoRealizado" row>
                        <v-radio
                          label="Sim"
                          :key="true"
                          :value="true"
                        ></v-radio>
                        <v-radio
                          label="Não"
                          :key="false"
                          :value="false"
                        ></v-radio>
                      </v-radio-group>
                    </v-col>
                  </v-row>

                  <!-- Seção de Anexos -->
                  <v-row class="mt-4">
                    <v-col cols="12">
                      <v-divider class="mb-4"></v-divider>
                      <h4 class="mb-3">Anexos</h4>

                      <!-- Upload de arquivo -->
                      <v-row v-if="!item.viewMode && item.editMode">
                        <v-col cols="12" md="8">
                          <v-file-input
                            v-model="item.novoAnexo"
                            label="Adicionar novo anexo"
                            outlined
                            dense
                            prepend-icon="mdi-paperclip"
                            accept=".pdf"
                            @change="marcarComoAlterado(item)"
                            hide-details="auto"
                          ></v-file-input>
                        </v-col>
                        <v-col cols="12" md="4">
                          <v-btn
                            color="primary"
                            outlined
                            @click="adicionarAnexo(item)"
                            :disabled="!item.novoAnexo"
                            class="mt-1"
                          >
                            <v-icon left>mdi-plus</v-icon>
                            Adicionar
                          </v-btn>
                        </v-col>
                      </v-row>

                      <!-- Lista de anexos -->
                      <v-row v-if="item.anexos && item.anexos.length > 0">
                        <v-col cols="12">
                          <v-list dense>
                            <v-list-item
                              v-for="(anexo, index) in item.anexos"
                              :key="index"
                              class="px-0"
                            >
                              <v-list-item-avatar>
                                <v-icon>{{
                                  getFileIcon(anexo.nome || anexo.nomeArquivo)
                                }}</v-icon>
                              </v-list-item-avatar>
                              <v-list-item-content>
                                <v-list-item-title>{{
                                  anexo.nome || anexo.nomeArquivo
                                }}</v-list-item-title>
                                <!-- <v-list-item-subtitle>
                                  {{ formatFileSize(anexo.tamanho) }} -
                                  {{ formatDate(anexo.dataUpload) }}
                                </v-list-item-subtitle> -->
                              </v-list-item-content>
                              <v-list-item-action>
                                <div class="d-flex">
                                  <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-btn
                                        icon
                                        small
                                        color="primary"
                                        v-bind="attrs"
                                        v-on="on"
                                        @click="baixarAnexo(anexo)"
                                      >
                                        <v-icon small>mdi-download</v-icon>
                                      </v-btn>
                                    </template>
                                    <span>Baixar anexo</span>
                                  </v-tooltip>

                                  <v-tooltip
                                    bottom
                                    v-if="!item.viewMode && item.editMode"
                                  >
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-btn
                                        icon
                                        small
                                        color="red"
                                        v-bind="attrs"
                                        v-on="on"
                                        @click="removerAnexo(item, index)"
                                      >
                                        <v-icon small>mdi-delete</v-icon>
                                      </v-btn>
                                    </template>
                                    <span>Remover anexo</span>
                                  </v-tooltip>
                                </div>
                              </v-list-item-action>
                            </v-list-item>
                          </v-list>
                        </v-col>
                      </v-row>

                      <!-- Mensagem quando não há anexos -->
                      <v-row v-else>
                        <v-col cols="12">
                          <v-alert color="info" outlined text class="ma-0">
                            <v-icon left>mdi-information</v-icon>
                            Nenhum anexo encontrado para este agente.
                          </v-alert>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>

                  <v-row v-if="item.editMode && !item.viewMode" class="mt-3">
                    <v-col class="text-right">
                      <v-btn
                        color="red"
                        @click="cancelarEdicao(item)"
                        class="mr-2"
                        text
                      >
                        Cancelar
                      </v-btn>
                      <v-btn color="primary" @click="salvarAgente(item)">
                        Salvar
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </td>
          </template>

          <template v-slot:footer.page-text="items">
            {{ items.pageStart }} - {{ items.pageStop }} de
            {{ items.itemsLength }}
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import ComboboxUnidadeRegional from "@/modules/ur/components/Combobox.vue";
import { AppAxisByProjectCombobox } from "@/modules/axis";
import MunicipioCombo from "@/modules/user/components/MunicipioCombo.vue";
import { municipioAdsApi, municipioAdsAnexoApi } from "@/apis";
import { mapGetters, mapActions } from "vuex";
import AppYesOrNOCombobox from "@/modules/groups/components/Combobox";
import Swal from "sweetalert2";
export const emailValidatorRegex = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;
export const dataRegexValidatior =
  /^([0]?[1-9]|[1|2][0-9]|[3][0|1])[./-]([0]?[1-9]|[1][0-2])[./-]([0-9]{4}|[0-9]{2})$/;
import { criarLinkRelatorio } from "@/helpers/gerarRelatorio";
import moment from "moment";
export default {
  components: {
    ComboboxUnidadeRegional,
    AppAxisByProjectCombobox,
    MunicipioCombo,
    AppYesOrNOCombobox,
  },
  computed: {
    ...mapGetters(["isGov", "config", "groupsConfig", "isFullAdmin", "user"]),
    editarMunicipiosAds() {
      return (
        this.isFullAdmin ||
        (this.config &&
          this.config.editarMunicipiosAds &&
          this.groupsConfig &&
          this.groupsConfig.editarMunicipiosAds)
      );
    },
    excluirMunicipiosAds() {
      return (
        this.isFullAdmin ||
        (this.config &&
          this.config.excluirMunicipiosAds &&
          this.groupsConfig &&
          this.groupsConfig.excluirMunicipiosAds)
      );
    },
    cadastrarMunicipiosAds() {
      return (
        this.isFullAdmin ||
        (this.config &&
          this.config.cadastrarMunicipiosAds &&
          this.groupsConfig &&
          this.groupsConfig.cadastrarMunicipiosAds)
      );
    },
    visualizarMunicipiosAds() {
      return (
        this.isFullAdmin ||
        (this.config &&
          this.config.visualizarMunicipiosAds &&
          this.groupsConfig &&
          this.groupsConfig.visualizarMunicipiosAds)
      );
    },

    municipiosPermitidos() {
      return this.user && this.user.permissoes;
    },
  },
  data() {
    return {
      municipioEixo: { municipio: [] },
      longestEixoMunicipio: 0,
      allMunicipio: [],
      allMunicipioEixo: [],
      selectedMunicipioEixo: [],
      eixoResposta: null,
      municipioEixosDiferentes: {},
      agentesDesenvolvimento: [],
      expanded: [],
      filtroAplicado: false, // Controla se o filtro foi aplicado
      headersAgentes: [
        { text: "Nome", value: "nome", sortable: true },
        { text: "Município", value: "nomeMunicipio", sortable: true },
        { text: "Ações", value: "actions", sortable: false, align: "center" },
      ],
      statusOptions: [
        { text: "Ativo", value: true },
        { text: "Inativo", value: false },
      ],
      // ...existing code...
    };
  },
  watch: {
    "municipioEixo.id_unidade_regional"(val) {
      if (val) {
        this.municipioEixo.municipio = this.allMunicipio.filter(
          (item) => item.id_unidade_regional == val
        );
      }
    },
    "municipioEixo.municipio"(val) {
      // Se não há municípios selecionados, resetar o filtro
      if (!val || val.length === 0) {
        this.filtroAplicado = false;
      }
    },
  },
  methods: {
    ...mapActions(["setLoading"]),
    filtrar() {
      if (this.municipioEixo.municipio.length > 0) {
        this.filtroAplicado = true;
        this.carregarAgentes();
      }
    },
    visualizarAgente(item) {
      console.log("this.expanded", this.expanded);
      const isExpanded = this.expanded?.includes(item) && item.viewMode;

      if (isExpanded) {
        this.fecharExpansao(item);
      } else {
        this.expanded = [];

        this.$set(item, "viewMode", true);
        this.$set(item, "editMode", false);

        this.$nextTick(() => {
          this.expanded = [item];
        });
      }
    },

    marcarComoAlterado(item) {
      // Só marca como alterado se não for novo e estiver em modo de edição

      if (!item.isNew && item.editMode) {
        this.$set(item, "hasUnsavedChanges", true);
      }
    },

    editarAgente(item) {
      const isExpanded = this.expanded?.includes(item) && item.editMode;
      console.log("item2", item);

      if (isExpanded) {
        this.cancelarEdicao(item);
      } else {
        this.expanded = [];

        this.$set(item, "editMode", true);
        this.$set(item, "viewMode", false);
        this.$set(item, "originalData", { ...item });

        this.$nextTick(() => {
          this.expanded = [item];
        });
      }
    },

    excluirAgente(item) {
      Swal.fire({
        title: "Confirmar exclusão",
        text: `Deseja realmente excluir o agente ${item.nome}?`,
        type: "warning",
        showCancelButton: true,
        confirmButtonText: "Sim, excluir",
        cancelButtonText: "Cancelar",
        reverseButtons: true,
      }).then((result) => {
        if (result.value) {
          this.confirmarExclusao(item);
        }
      });
    },

    confirmarExclusao(item) {
      // Aqui você faria a chamada da API para excluir

      this.setLoading(true);
      municipioAdsApi
        .delete(item.adId)
        .then(() => {
          const index = this.agentesDesenvolvimento.findIndex(
            (agent) => agent.id === item.id
          );
          if (index > -1) {
            this.agentesDesenvolvimento.splice(index, 1);
            this.$notification.success("Agente excluído com sucesso!");
          }
          this.setLoading(false);
        })
        .catch((error) => {
          console.error("Erro ao excluir agente:", error);
          this.$notification.error("Erro ao excluir agente");
          this.setLoading(false);
        });
    },

    salvarAgente(item) {
      if (!item.nome || !item.municipio) {
        this.$notification.error("Nome e município são obrigatórios", {
          duration: 300,
        });
        return;
      }

      if (
        (item.email1 && !emailValidatorRegex.test(item.email1)) ||
        (item.email2 && !emailValidatorRegex.test(item.email2))
      ) {
        this.$notification.error("Email inválido", {
          duration: 300,
        });
        return;
      }

      if (item.nascimento && !dataRegexValidatior.test(item.nascimento)) {
        this.$notification.error("Data de nascimento inválida", {
          duration: 300,
        });
        return;
      }

      const ad = {
        ...item,
        nomeMunicipio: item.municipio.nome,
        codigoIbge: item.municipio.codigoIBGE,
        cpf: item.cpf && item.cpf.replace(/\D/g, ""), // Remover caracteres não numéricos do CPF
      };

      // Criar FormData
      const formData = new FormData();

      // Adicionar todos os campos do objeto (exceto anexos)
      Object.keys(ad).forEach((key) => {
        if (key !== "anexos" && ad[key] !== null && ad[key] !== undefined) {
          formData.append(key, ad[key]);
        }
      });

      this.setLoading(true);

      const salvarRequisicao = item.adId
        ? municipioAdsApi.edit(formData)
        : municipioAdsApi.add(formData);

      salvarRequisicao
        .then(async (response) => {
          Object.assign(item, response.data);

          const adIdSalvo =
            (response.data && response.data.adId) || item.adId || ad.adId;

          await this.salvarAnexos(item, adIdSalvo);

          this.$set(item, "editMode", false);
          this.$set(item, "viewMode", false);
          if (item.originalData) {
            delete item.originalData;
          }
          if (item.isNew) {
            delete item.isNew;
          }
          if (item.hasUnsavedChanges) {
            delete item.hasUnsavedChanges;
          }

          this.expanded = [];
          this.carregarAgentes();

          this.$notification.success("Agente salvo com sucesso!");
        })
        .catch((error) => {
          console.error("Erro ao salvar agente:", error);
          this.$notification.error("Erro ao salvar agente");
        });
    },

    async salvarAnexos(item, adId) {
      const anexosNovos = (item.anexos || []).filter((anexo) => anexo.arquivo);

      if (!adId || anexosNovos.length === 0) {
        return;
      }

      for (let i = 0; i < anexosNovos.length; i++) {
        const formData = new FormData();
        formData.append("adId", adId);
        formData.append("arquivo", anexosNovos[i].arquivo);

        await municipioAdsAnexoApi.add(formData);
      }
    },

    fecharExpansao(item) {
      this.expanded = [];
      console.log("aqui");
      this.$set(item, "viewMode", false);
      this.$set(item, "editMode", false);
      if (item.originalData) {
        delete item.originalData;
      }
    },

    cancelarEdicao(item) {
      if (item.originalData) {
        Object.assign(item, item.originalData);
        delete item.originalData;
      }

      // Limpar marcação de alterações não salvas
      if (item.hasUnsavedChanges) {
        delete item.hasUnsavedChanges;
      }

      // Fechar expansão
      this.fecharExpansao(item);
    },

    carregarAgentes() {
      this.setLoading(true);
      const codigosIbge = this.municipioEixo.municipio.map((m) => m.codigoIBGE);

      municipioAdsApi
        .getAgentesByCodigoIBGE(codigosIbge)
        .then((response) => {
          if (response.data && response.data.length > 0) {
            this.agentesDesenvolvimento = response.data.map((item) => ({
              ...item,
              editMode: false,
              viewMode: false,
              hasUnsavedChanges: false,
              isNew: false,
              anexos: item.municipioAdAnexos || [],
              novoAnexo: null,
            }));
          } else {
            this.agentesDesenvolvimento = [];
          }
          this.setLoading(false);
        })
        .catch((error) => {
          this.setLoading(false);
          console.error("Erro ao carregar agentes:", error);
          this.$notification.error(
            "Erro ao carregar agentes de desenvolvimento"
          );
        });

      // Dados de exemplo - substitua pela chamada da API
    },
    exportarAgentes() {
      municipioAdsApi
        .gerarXls()
        .then((resp) => {
          this.setLoading(false);
          const nome = `Agentes de Desenvolvimento - ${moment().format(
            "DD_MM_YYYY_HH_mm"
          )}`;
          criarLinkRelatorio(resp.data, nome);
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$notification.error("Erro ao gerar eXcel");
        });
    },
    adicionarNovoAgente() {
      const novoAgente = {
        id: Date.now(), // ID temporário único
        nome: "",
        cpf: "",
        email1: "",
        email2: "",
        telefone: "",
        nascimento: "",
        escolaridade: "",
        codigoIbge: "",
        nomeMunicipio: "",
        status: true,
        editMode: true,
        viewMode: false,
        isNew: true,
        anexos: [],
        novoAnexo: null,
      };

      this.agentesDesenvolvimento.unshift(novoAgente);

      this.$nextTick(() => {
        this.expanded = [novoAgente];
      });
    },

    // Métodos para gerenciamento de anexos
    adicionarAnexo(item) {
      if (!item.novoAnexo) return;

      const arquivo = item.novoAnexo;
      const novoAnexo = {
        id: Date.now(),
        nome: arquivo.name,
        tamanho: arquivo.size,
        tipo: arquivo.type,
        dataUpload: new Date(),
        arquivo: arquivo,
      };

      if (!item.anexos) {
        this.$set(item, "anexos", []);
      }

      item.anexos.push(novoAnexo);
      item.novoAnexo = null;
      this.marcarComoAlterado(item);

      this.$notification.success("Anexo adicionado com sucesso!");
    },

    removerAnexo(item, index) {
      if (item.anexos && item.anexos[index]) {
        const anexo = item.anexos[index];

        Swal.fire({
          title: "Confirmar remoção",
          text: `Deseja realmente remover o arquivo "${anexo.nome}"?`,
          type: "warning",
          showCancelButton: true,
          confirmButtonText: "Sim, remover",
          cancelButtonText: "Cancelar",
          reverseButtons: true,
        }).then((result) => {
          if (result.value) {
            if (anexo.municipioAdAnexosId) {
              this.setLoading(true);

              municipioAdsAnexoApi
                .delete(anexo.municipioAdAnexosId)
                .then(() => {
                  this.setLoading(false);

                  item.anexos.splice(index, 1);
                  this.marcarComoAlterado(item);
                  this.$notification.success("Anexo removido com sucesso!");
                })
                .catch(() => {
                  this.setLoading(false);

                  this.$notification.error("Erro ao remover anexo");
                });
            } else {
              item.anexos.splice(index, 1);
              this.marcarComoAlterado(item);
              this.$notification.success("Anexo removido com sucesso!");
            }
          }
        });
      }
    },

    baixarAnexo(anexo) {
      // Se for um arquivo novo (ainda não salvo no servidor)
      if (anexo.arquivo) {
        var fileURL = window.URL.createObjectURL(new Blob([anexo.arquivo]));
        var fileLink = document.createElement("a");

        fileLink.href = fileURL;
        fileLink.download = anexo.nome;
        document.body.appendChild(fileLink);
        fileLink.click();
      } else {
        this.setLoading(true);
        municipioAdsApi
          .downloadAnexo(anexo.municipioAdAnexosId)
          .then((resp) => {
            var fileURL = window.URL.createObjectURL(new Blob([resp.data]));
            var fileLink = document.createElement("a");

            fileLink.href = fileURL;
            fileLink.download = anexo.nomeArquivo;
            document.body.appendChild(fileLink);
            fileLink.click();
            this.setLoading(false);
          })
          .catch(() => {
            this.setLoading(false);
          });
      }
    },

    getFileIcon(nomeArquivo) {
      const extensao = nomeArquivo.split(".").pop().toLowerCase();

      switch (extensao) {
        case "pdf":
          return "mdi-file-pdf-box";
        case "doc":
        case "docx":
          return "mdi-file-word-box";
        case "jpg":
        case "jpeg":
        case "png":
        case "gif":
          return "mdi-file-image";
        case "txt":
          return "mdi-file-document";
        case "xls":
        case "xlsx":
          return "mdi-file-excel-box";
        default:
          return "mdi-file";
      }
    },

    formatFileSize(bytes) {
      if (bytes === 0) return "0 Bytes";

      const k = 1024;
      const sizes = ["Bytes", "KB", "MB", "GB"];
      const i = Math.floor(Math.log(bytes) / Math.log(k));

      return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];
    },

    formatDate(date) {
      return moment(date).format("DD/MM/YYYY HH:mm");
    },
  },
  mounted() {},
};
</script>
<style lang="scss">
.municipioEixoTable td {
  padding: 15px 10px !important;
  border-top: thin solid rgba(0, 0, 0, 0.12);
  width: calc(100% / 10);
}

.municipioEixoTable td:not(:last-of-type) {
  border-right: thin solid rgba(0, 0, 0, 0.12);
}

.checkbox-cidade-empreendedora label {
  font-size: 10px !important;
}
</style>
